import { useEffect, useRef } from 'react';

import { useUserEnvironment } from 'store/hooks/useUserEnvironment';
import { initializeAds } from 'zustand-stores/adStore';
import { onClientHydrated } from 'zustand-stores/renderingStateStore';

export function useAdManager(noAds: boolean = false) {
  const { user, environment } = useUserEnvironment();

  const adManagerLoadedRef = useRef(false);

  useEffect(() => {
    onClientHydrated(() => {
      // @TODO: Can the environment be `null` before hydration?
      if (!noAds && environment && !adManagerLoadedRef.current) {
        initializeAds({ user, environment });
        adManagerLoadedRef.current = true;
      }
    });
  }, [environment, noAds, user]);
}
